import { ApiClient } from '../../ApiClient';
import { ConnectionDTO } from '../dto/MarketplaceDTOs';
import { Import4YouInventory } from '@domain/connection/models/Import4YouInventory';
import { InventorySyncEventItem } from '@domain/connection/models/InventorySyncEvent';

export class Import4YouConnectorDataSource {

  constructor(private api: ApiClient) {
  }

  async addImport4YouConnection(client_id: string, client_secret: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>('/connections/import4you', {
      client_id,
      client_secret
    });
    return response.data;
  }

  async fetchInventory(connectionId: string): Promise<Import4YouInventory[]> {
    const response = await this.api.get<Import4YouInventory[]>(`/connections/import4you/warehouse/inventory?connectionId=${connectionId}`);
    return response.data;
  }

  async fetchProductsInventory(connectionId: string): Promise<InventorySyncEventItem[]> {
    const response = await this.api.get<InventorySyncEventItem[]>(`/connections/import4you/warehouse/products/inventory?connectionId=${connectionId}`);
    return response.data;
  }
}   